<template>
    <div id="integrationZapier" >
    <iframe
    ref="iframeRef"
          id="iframeRef"
          src="https://zapier.com/editor/sandbox/draft/1/setup"
          width="100%"
          class="thin-scrollbar iframe-container">
    </iframe>
    </div>
</template>
<script>
export default {
  name: "integration",
}
</script>